import Select from "react-select";
import React, {useEffect, useState} from "react";
import {SelectOptionCollection} from "Model/Select/SelectOptionCollection";
import {SelectOption, SelectOptionType} from "Model/Select/SelectOption";
import {renderHtml} from "Services/View/ViewUtils";
import {ActivitySession} from "Model/Activity/ActivitySession";

interface Props {
    onChange: (newValue: SelectOptionType | null) => void,
    value?: any,
    classes?: string,
}

export const InscriptionValidationTypes = [
    {value: 1, label: 'Por actividad'},
    {value: 2, label: 'Por modalidad'},
]

export const getInscriptionValidationType = (value: number): { label: string; value: string } | null => {
    const option = InscriptionValidationTypes.find((item) => item.value === value);
    return option ? { label: option.label, value: option.value.toString() } : null;
}

export const InscriptionValidationTypeSelect: React.FC<Props> = (props) => {

    const [options, setOptions] = useState<any>(InscriptionValidationTypes)
    const [value, setValue] = useState<SelectOption|null>(props.value ?? InscriptionValidationTypes[1])

    const onChange = (option:any) => {
        props.onChange(option)
    }

    useEffect(() => {
        setValue(props.value)
    }, [props.value]);

    return (
        <Select
            options={options}
            placeholder={""}
            noOptionsMessage={() => "No hay resultados"}
            isClearable={true}
            loadingMessage={() => "Cargando ..."}
            onChange={(option:any) => {
                setValue(option)
                onChange(option)
            }}
            className={props.classes ?? ''}
            value={value}
        />
    )
}
